import { useMutation, useQuery, useQueryClient } from "react-query";
import { apiCall } from "Apis/BaseApi";
import { IPaginatedList } from "Apis/Models/IPaginatedList";
import {IQueryParams} from "./Models/IQueryParams";
import {ITagDto} from "./Models/ITagDto";

export const TAGS_CACHE_KEY = 'TAGS_CACHE_KEY '
export const useTags = (queryable: Partial<IQueryParams> | null = null) => {
    return useQuery<IPaginatedList<ITagDto>>([TAGS_CACHE_KEY, queryable], async () => {
        return await apiCall<IPaginatedList<ITagDto>>({
            url: `/tags`,
            method: 'GET',
            queryParams: queryable
        })
    });
}

export const useTag = (id: number) => {
    return useQuery<ITagDto>([TAGS_CACHE_KEY, id], async () => {
        return await apiCall<ITagDto>({
            url: `/tags/${id}`,
            method: 'GET',
        })
    });
}

export const useMutateTag = () => {
    
    const queryClient = useQueryClient();
    
    return useMutation(async (tag: ITagDto): Promise<ITagDto> => {
        if (!tag.id) {
            return await apiCall<ITagDto>({
                url: `/tags`,
                method: 'POST',
                data: tag
            })
        } else {
            return await apiCall<ITagDto>({
                url: `/tags/${tag.id}`,
                method: 'PUT',
                data: tag
            })
        }
    }, {
        onSuccess: async () => {
            await queryClient.invalidateQueries(TAGS_CACHE_KEY)
        }
    })
}

export const useDeleteTag = () => {

    const queryClient = useQueryClient();

    return useMutation(async (tag: ITagDto): Promise<ITagDto> => {
        return await apiCall<ITagDto>({
            url: `/tags/${tag.id}`,
            method: 'DELETE',
        })
    }, {
        onSuccess: async () => {
            await queryClient.invalidateQueries(TAGS_CACHE_KEY)
        }
    })
}